// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { store } from './store/store'
import router from './router'

import Buefy from 'buefy'
import Upload from '@/components/elements/AttachmentQuestion'

import PrettyCheckbox from 'pretty-checkbox-vue'

import VueDropdown from 'vue-dynamic-dropdown'
import Datepicker from 'vuejs-datepicker'

import VueResource from 'vue-resource'

import './assets/css/customBulma.css'
import 'buefy/dist/buefy.css'

import 'bulma-extensions/dist/css/bulma-extensions.min.css'
import 'bulma-o-steps/bulma-steps.min.css'

import 'pretty-checkbox/dist/pretty-checkbox.min.css'

import { Slider, Icon, Badge } from 'iview'
// import 'iview/dist/styles/iview.css'
import './assets/css/iview.css'

import tracking from './assets/js/tracking'

Vue.use(Buefy)

Vue.component('Slider', Slider)
Vue.component('Icon', Icon)
Vue.component('Badge', Badge)

Vue.component('vue-dropdown', VueDropdown)
Vue.component('datepicker', Datepicker)

Vue.component('upload', Upload)

Vue.use(PrettyCheckbox)

Vue.use(VueResource)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  tracking,
  components: { App, Upload },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js